import React, { Component } from 'react';
import cx from 'classnames';
import SubstitutionOptionsModal from './SubstitutionOptionsModal';
import PropTypes from 'prop-types';
import * as Constants from '../../constants';
require('./ProductAlternatesInfo.scss');

const initialState = {
  loading: false,
  alternatesFetched: false,
  isSubstituteModalOpen: false,
  isVariantSelectionOpen: false,
  variants: [],
  substitutes: [],
  currentVariant: {},
  showSimilarProducts: false,
  showVariants: false,
  showSubstitutes: false,
  originalProduct: {}
};

const STATUS_CHECK_OPTIONS = 'STATUS_CHECK_OPTIONS';
const STATUS_SUBSTITUTED = 'STATUS_SUBSTITUTED';
const STATUS_IS_SUBSTITUTE = 'STATUS_IS_SUBSTITUTE';

class ProductAlternatesInfo extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    const {
      productDetails,
      isSubstitutionAllowed
    } = this.props;

    const showSubstitutes = isSubstitutionAllowed && productDetails.productSubstitutionAttributes != null;
    const showVariants = productDetails.hasVariants;
    const showSimilarProducts = productDetails.similarProductsAttributes != null && !(showSubstitutes || showVariants);

    this.setState({
      originalProduct: {
        id: productDetails.id,
        name: productDetails.name,
        manufacturer_name: productDetails.manufacturer,
        subtitle: productDetails.measurementUnit,
        discounted_mrp: productDetails.salePriceDecimal,
        composition: productDetails.composition
      },
      showSubstitutes: showSubstitutes,
      showVariants: showVariants,
      showSimilarProducts: showSimilarProducts,
    });
  }

  handleVariantSelection = (variantUcode) => {
    this.addSubstitutionEventLog(Constants.LOG_TYPE_SUBSTITUTE_SELECTED, variantUcode, Constants.TYPE_VARIANT);
    const {
      variants
    } = this.state;

    const selectedVariantIndex = variants.map(function (variant) {
      return variant.ucode
    }).indexOf(variantUcode);
    const selectedVariant = variants[selectedVariantIndex];

    this.props.handleSubstitution(selectedVariant, Constants.TYPE_VARIANT);
    this.setState({ isVariantSelectionOpen: false });
  }

  handleProductSubstitution = (product) => {
    const substituteType = this.state.showSimilarProducts ? Constants.TYPE_SIMILAR_PRODUCT : Constants.TYPE_SUBSTITUTE;
    this.addSubstitutionEventLog(Constants.LOG_TYPE_SUBSTITUTE_SELECTED, product.ucode, substituteType);
    this.props.handleSubstitution(product, substituteType);
  }

  addSubstitutionEventLog(logType, subsUcode, substituteType) {
    const {
      addSubstitutionEventLog,
      isFlipRecommended,
      originalProduct: { ucode, availabilityLevel }
    } = this.props;

    addSubstitutionEventLog([{
      logType: logType,
      isFlipRecommended: isFlipRecommended,
      originalUcode: ucode,
      availability: availabilityLevel,
      substituteUcode: subsUcode,
      substituteType: substituteType,
      isOriginalFlipForGreen: !!((this.props.originalProduct.substituteDetails && this.props.originalProduct.substituteDetails.flip_for_green)),
      hasHighMarginSubstitutes: !!(this.props.originalProduct.substituteDetails && this.props.originalProduct.substituteDetails.has_higher_margin_substitutes),
    }]);
  }

  handleVariantDropdownSelect = () => {
    const {
      isVariantSelectionOpen
    } = this.state;

    if (!isVariantSelectionOpen && this.shouldFetchSubstituesAndVariants()) {
      this.fetchProductAlternates(false);
      this.addSubstitutionEventLog(Constants.LOG_TYPE_SUBSTITUTES_VIEWED, null, Constants.TYPE_VARIANT);
    }

    this.setState({ isVariantSelectionOpen: !isVariantSelectionOpen });
  }

  handleSubstitutesPopupSelect = () => {
    const {
      showSimilarProducts
    } = this.state;

    if (showSimilarProducts) {
      this.fetchSimilarProducts();
    } else {
      this.fetchProductAlternates(true);
    }

    this.addSubstitutionEventLog(Constants.LOG_TYPE_SUBSTITUTES_VIEWED, null, showSimilarProducts ? Constants.TYPE_SIMILAR_PRODUCT : Constants.TYPE_SUBSTITUTE);
  }

  fetchSimilarProducts() {
    this.setState({ loading: true });
    this.props.fetchSimilarProducts(this.props.productDetails.id).then((response) => {
      if (this.isAPICallSuccessful(response)) {
        this.setState({
          substitutes: response.data.similarProducts,
          isSubstituteModalOpen: true,
          alternatesFetched: true,
          loading: false
        }, () => {
          this.state.substitutes.length && this.addSubstitutionEventLog(Constants.LOG_TYPE_SUBSTITUTES_AVAILABLE, null, Constants.TYPE_SIMILAR_PRODUCT);
        });
      }
      this.setState({
        alternatesFetched: this.isAPICallSuccessful(response),
        loading: false,
      });
    });
  }

  fetchProductAlternates(openModal) {
    this.setState({ loading: true });
    this.props.fetchProductAlternates(this.props.productDetails.id).then((response) => {
      if (this.isAPICallSuccessful(response)) {
        const substitute_details = response.data.variants && response.data.variants.currentVariant && response.data.variants.currentVariant.substitute_details;
        const originalHasHighVariableAvailable = substitute_details ? substitute_details.has_high_margin_substitutes : false;
        this.setState({
          variants: Object.values(response.data.variants.availableVariants),
          substitutes: response.data.alternates,
          isSubstituteModalOpen: openModal,
          alternatesFetched: true,
          loading: false,
          originalHasHighVariableAvailable,
        }, () => {
          this.state.variants.length && this.addSubstitutionEventLog(Constants.LOG_TYPE_SUBSTITUTES_AVAILABLE, null, Constants.TYPE_VARIANT);
          this.state.substitutes.length && this.addSubstitutionEventLog(Constants.LOG_TYPE_SUBSTITUTES_AVAILABLE, null, Constants.TYPE_SUBSTITUTE);
        });
      }
      this.setState({
        alternatesFetched: this.isAPICallSuccessful(response),
        loading: false,
      });
    });
  }

  isAPICallSuccessful(response) {
    return response.status === 1;
  }

  shouldFetchSubstituesAndVariants() {
    const {
      showSimilarProducts,
      showSubstitutes,
      showVariants,
      variants,
      substitutes
    } = this.state;

    return (showSimilarProducts || showSubstitutes || showVariants) && (variants.length === 0 && substitutes.length === 0);
  }

  render() {
    const {
      variants,
      substitutes,
      isVariantSelectionOpen,
      isSubstituteModalOpen,
      loading,
      showSimilarProducts,
      showSubstitutes,
      showVariants,
    } = this.state;
    const {
      originalProduct,
      isSubstituted,
      isOriginalProduct,
      resetSubstitute,
    } = this.props;

    let substitutionStatus = STATUS_CHECK_OPTIONS;
    if (isSubstituted && isOriginalProduct) {
      substitutionStatus = STATUS_SUBSTITUTED;
    } else if (isSubstituted && !isOriginalProduct) {
      substitutionStatus = STATUS_IS_SUBSTITUTE;
    }

    return (
      <div className={cx("ProductAlternatesInfo", { 'pe-loading': loading })}>
        {substitutionStatus === STATUS_SUBSTITUTED &&
          (<div className="substitutedProduct">
            <img src={require('@images/substitution.svg')} />
            <span>Replaced for {originalProduct.name}</span>
            <button onClick={resetSubstitute}>KEEP ORIGINAL</button>
          </div>)
        }
        {substitutionStatus === STATUS_IS_SUBSTITUTE &&
          (<div className="isSubstitute">
            <img src={require('@images/substitution.svg')} />
            Replaced for {originalProduct.originalProductDetails.name}
          </div>)
        }
        {(substitutionStatus !== STATUS_SUBSTITUTED && (showSimilarProducts || showSubstitutes || showVariants)) &&
          (<div className="alternateOptionsContainer">
            <div className="selectVariantContainer">
              {showVariants && (<button className="selectVariantBtn alternateBtn" onClick={this.handleVariantDropdownSelect}>
                SELECT VARIANT/PACK
                <img src={require('@images/chevron_down_yellow.svg')} />
              </button>)}
              {showVariants && (<table className={cx('variantDropdown', { 'hide': !isVariantSelectionOpen })}>
                <tbody>
                  <tr className="header">
                    <td colSpan="3">VARIANTS / PACK</td>
                  </tr>
                  {variants.map(({ name, id, subtitle, discounted_mrp, ucode }) => (
                    <tr key={id} className="variantRow" onClick={() => this.handleVariantSelection(ucode)}>
                      <td className="variantName">{name}</td>
                      <td className="variantPackform">{subtitle}</td>
                      <td className="variantMRP">₹{discounted_mrp || '---'}</td>
                    </tr>)
                  )}
                </tbody>
              </table>)}
            </div>
            {(showSimilarProducts || showSubstitutes) ?
              (
                showSimilarProducts ?
                  <button className="selectSimilarBtn alternateBtn" onClick={this.handleSubstitutesPopupSelect}>VIEW SIMILAR PRODUCTS</button> :
                  <button className="selectSubstitutionBtn alternateBtn" onClick={this.handleSubstitutesPopupSelect}>AVAILABLE ALTERNATIVE</button>
              )
              : null
            }
            <SubstitutionOptionsModal
              show={isSubstituteModalOpen}
              onClose={() => this.setState({ isSubstituteModalOpen: false })}
              onSelect={this.handleProductSubstitution}
              originalProduct={this.state.originalProduct}
              substituteList={substitutes}
              showSimilarProducts={showSimilarProducts}
            />
          </div>)
        }
      </div>
    );
  }
}

ProductAlternatesInfo.propTypes = {
  originalProduct: PropTypes.object.isRequired,
  isSubstituted: PropTypes.bool,
  isOriginalProduct: PropTypes.bool,
  handleSubstitution: PropTypes.func.isRequired,
  resetSubstitute: PropTypes.func.isRequired,
  fetchProductAlternates: PropTypes.func.isRequired,
  fetchSimilarProducts: PropTypes.func.isRequired,
  addSubstitutionEventLog: PropTypes.func.isRequired,
  productDetails: PropTypes.object.isRequired,
  isFlipRecommended: PropTypes.bool,
};

ProductAlternatesInfo.defaultProps = {
  isSubstituted: false,
  isOriginalProduct: true,
  isFlipRecommended: false,
}

export default ProductAlternatesInfo;